import { FC } from "react";
import React from "react";
import { makeStyles, createStyles, FormControl, Grid } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Checkbox } from "../core/Checkbox";
import { Colors } from "../../styles";
import { useStyles } from "../../useStyles";
const useFormControlStyle = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        containerError: {
            backgroundColor: Colors.radiantRedFill,
            borderColor: Colors.radiantRed,
            borderStyle: "solid",
            borderWidth: "1px",
            borderRadius: 8,
        },
        formControlLabelStyle: {
            marginRight: 110,
        },
        checkboxStyle: {
            marginRight: 8,
        },
    }),
);

export const RemovalReconstructionProductClassesForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<
        ChangeNames.REMOVAL_RECONSTRUCTION_PRODUCT_CLASSES
    >();
    const formControlClasses = useFormControlStyle();

    return (
        <div style={{ marginTop: 32 }}>
            <FormControl
                component="fieldset"
                className={classes.container}
                style={{ display: "flex" }}
            >
                <h4 className={classes.h4} style={{ marginTop: 0, marginBottom: 0 }}>
                    Für welche Gewerke soll ein Wiederanschluss erfolgen?
                </h4>
                <Grid container spacing={7} className={formControlClasses.container}>
                    <Grid item>
                        {values.removalReconstructionProductClasses.value.power !== undefined && (
                            <FormControlLabel
                                isCheckBox={true}
                                className={formControlClasses.formControlLabelStyle}
                                control={
                                    <Checkbox
                                        className={formControlClasses.checkboxStyle}
                                        value="power"
                                        checked={
                                            values.removalReconstructionProductClasses.value.power
                                        }
                                        onChange={(event, checked) =>
                                            setValues(values => {
                                                values.removalReconstructionProductClasses.value.power = checked;
                                            })
                                        }
                                    />
                                }
                                label="Strom"
                                error={values.removalReconstructionProductClasses.error !== null}
                            />
                        )}
                        {values.removalReconstructionProductClasses.value.gas !== undefined && (
                            <FormControlLabel
                                isCheckBox={true}
                                control={
                                    <Checkbox
                                        className={formControlClasses.checkboxStyle}
                                        value="gas"
                                        checked={
                                            values.removalReconstructionProductClasses.value.gas
                                        }
                                        onChange={(event, checked) =>
                                            setValues(values => {
                                                values.removalReconstructionProductClasses.value.gas = checked;
                                            })
                                        }
                                    />
                                }
                                label="Gas"
                                error={values.removalReconstructionProductClasses.error !== null}
                            />
                        )}
                    </Grid>
                </Grid>
            </FormControl>
        </div>
    );
};
